import React, { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { FaEnvelope, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import NewsletterService from "../../services/newsletterService";
import "../../styles/newsletter.css";

const NewsletterSubscribe = ({
  source = "website",
  variant = "default",
  className = "",
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await NewsletterService.subscribe(email, source);
      setSuccess(true);
      setEmail("");
      toast.success("Successfully subscribed to newsletter!");
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      if (error.response?.status === 409) {
        setError("This email is already subscribed");
      } else {
        setError("Failed to subscribe. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (variant === "inline") {
    return (
      <div className={`newsletter-inline ${className}`}>
        <div className="newsletter-inline-content">
          <div className="newsletter-inline-icon">
            <FaEnvelope />
          </div>
          <div className="newsletter-inline-text">
            <h6>Subscribe to our Newsletter</h6>
            <p>Get the latest updates on courses, webinars, and offers</p>
          </div>
          <form onSubmit={handleSubmit} className="newsletter-inline-form">
            <div className="input-group">
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <Button type="submit" variant="primary" disabled={loading}>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Subscribe"
                )}
              </Button>
            </div>
            {error && <small className="text-danger">{error}</small>}
            {success && (
              <small className="text-success">Subscribed successfully!</small>
            )}
          </form>
        </div>
      </div>
    );
  }

  // Default variant - card style
  return (
    <div className={`newsletter-card ${className}`}>
      <div className="newsletter-card-inner">
        <div className="newsletter-icon">
          <FaEnvelope />
        </div>
        <h5>Subscribe to Our Newsletter</h5>
        <p>
          Stay updated with our latest courses, webinars, and exclusive offers.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="input-group mb-2">
            <span className="input-group-text">
              <FaEnvelope />
            </span>
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>
          {error && (
            <Alert variant="danger" className="py-1 small">
              {error}
            </Alert>
          )}
          {success && (
            <Alert variant="success" className="py-1 small">
              Subscribed successfully!
            </Alert>
          )}
          <Button
            type="submit"
            variant="primary"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Subscribe Now"
            )}
          </Button>
        </form>

        <p className="newsletter-note small text-muted mt-2">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </div>
  );
};

export default NewsletterSubscribe;
